/* global jQuery, elementorFrontend */

jQuery( window ).on( 'elementor/frontend/init', () => {

	/**
	* MTD Slider
	* Set up swiper.js instance for the MTD Slider widget
	*
	* @param $element The widget wrapper element as a jQuery element
	* @param $ The jQuery alias
	*/
	const mtdSliderHandler = ( $element, $ ) => {
		let widget_id = $element.data('id');

		let slider_main = '#' + widget_id + '-for';
		let slider_nav = '#' + widget_id + '-nav';

		$(slider_main).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: true,
			fade: true,
			asNavFor: slider_nav,
			prevArrow: $element.find('.mtd-slider__prev'),
			nextArrow: $element.find('.mtd-slider__next'),
			appendDots: $element.find('.mtd-slider__dots-holder'),
			autoplay: true,
			autoplaySpeed: 5000
		});

		$(slider_nav).slick({
			dots: false,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: slider_main
		});
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/mtd-slider.default', mtdSliderHandler );

} );